import React, { useState, useEffect } from "react";
import styled from "styled-components";

const Container = styled.div`
    background-color: #f7f5f6;
    min-height: 100%;
    width: 100%;
    overflow-x: hidden;
    scroll-snap-type: x mandatory;
    display: flex;
    height: 100%;
`;

function useForceUpdate() {
    const [value, setValue] = useState(0);
    return () => setValue((value) => ++value);
}

const MultiStepForm = (props) => {
    const forceUpdate = useForceUpdate();

    const handleChange = (event) => {
        const newValues = props.values;
        const { name, value, extraField, contextRuleId } = event.target;

        if (extraField && contextRuleId) {
            if (!newValues?.extra) {
                newValues.extra = {};
            }

            newValues.extra = { ...newValues.extra, [name]: { value, contextRuleId } };
        } else {
            newValues[name] = value;
        }

        props.setValues(newValues);
        forceUpdate();
    };

    const [currentStep, setCurrentStep] =
        props.currentStep && props.setCurrentStep ? [props.currentStep, props.setCurrentStep] : useState(1);

    const nextStep = () => {
        if (currentStep >= props.children.lenght) return;
        setCurrentStep(currentStep + 1);
    };

    const prevStep = () => {
        if (currentStep <= 1) return;
        setCurrentStep(currentStep - 1);
    };

    const goToStep = (step) => {
        if (currentStep <= 1) return;
        setCurrentStep(step);
    };

    useEffect(() => {
        if (!props.currentStep) return;
        props.setCurrentStep(currentStep);
    }, [currentStep]);

    return (
        <>
            <Container>
                {React.cloneElement(props.children[currentStep - 1], {
                    ...props.children[currentStep],
                    nextStep,
                    goToStep,
                    prevStep,
                    handleChange,
                    values: props.values,
                    currentStep,
                    totalSteps: React.Children.count(props.children),
                })}
            </Container>
        </>
    );
};

export default MultiStepForm;
